module.exports = __webpack_public_path__ + "static/media/project.d0e75cee.svg";